function Position({ attributes, setAttributes }) {
  return (
    <div>
      <li className="bullet-item">
        The position in the chromosome according to <b>dbSNP</b>, the{' '}
        <a className="tt" target="blank" href="http://www.ncbi.nlm.nih.gov/projects/SNP/">
          NCBI Short Genetic Variations database{' '}
        </a>
      </li>
    </div>
  );
}

export default Position;
